// AppRedirect.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Brand } from "./constants/brand";

const AppRedirect = () => {
  const location = useLocation();

  useEffect(() => {
     // Get the full URL (including path and query string)
    const fullPath = location.pathname + location.search;
    const deepLinkUrl = window.location.origin + fullPath;
    // const fullPath = location.pathname; // e.g., /open/product/123
    // const deepLinkUrl = `https://yourdomain.com${fullPath}`;

    const userAgent = navigator.userAgent;
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

    // null when this brand has no store link yet: no redirect
    const fallbackUrl = isAndroid
      ? Brand.androidStoreUrl
      : Brand.iosStoreUrl;

      const hasRedirected = sessionStorage.getItem("redirected");

    if (isMobile && !hasRedirected && fallbackUrl) {
      sessionStorage.setItem("redirected", "true");
    // fallback in case OS doesn't handle it
      const timeout = setTimeout(() => {
      // iOS/Android will handle it if app supports App Links / Universal Links
    window.location.href = fallbackUrl;
      }, 1500);

      return () => clearTimeout(timeout);
    }

  }, [location]);

  return <p>Redirecting to the app...</p>;
};

export default AppRedirect;